import { render, staticRenderFns } from "./DialogInitialSettings.vue?vue&type=template&id=b28d0a32"
import script from "./DialogInitialSettings.vue?vue&type=script&lang=ts"
export * from "./DialogInitialSettings.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports